// import '../styles/'
import Navbar from '../../../components/Navbar'
import Sanciones from '../../administrador/components/SancionesForm'

const InformesInicio = () => {
    
    
    return(
        <div>
            <Navbar></Navbar>
            <Sanciones></Sanciones>
        </div>
    );
}

export default InformesInicio;